import React, { useState, useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { clearLoginError, login } from "../contents/redux/actions/authActions";
import { toast } from "react-toastify";
import styles from "./utilities/cssmodules/Login.module.css";
import { PublicOutlined, VisibilityOffOutlined, VisibilityOutlined } from "@mui/icons-material";
import logo from "../images/lcc_logo.png"


const Login = () => {
  const [credentials, setCredentials] = useState({ email: "", password: "" });
  const [showPassword, setShowPassword] = useState(false);
  const [invalidEmailError, setInvalidEmailError] = useState("");
  const [isEmailValid, setIsEmailValid] = useState(true);
  const [loginLoading, setLoginLoading] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loginError = useSelector((state) => state.auth.loginError);

  const emailRegExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCredentials({ ...credentials, [name]: value });

    if (name === "email") {
      if (!emailRegExp.test(value)) {
        setInvalidEmailError("This doesn't look like a valid email.");
        setIsEmailValid(false);
      } else {
        setInvalidEmailError("");
        setIsEmailValid(true);
      }
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!isEmailValid || !credentials.email || !credentials.password) {
      toast.error("Please enter a valid email and password.");
      return;
    }
    setLoginLoading(true);
    dispatch(login(credentials, navigate))
      .then(() => {
        setLoginLoading(false);
      })
      .catch((error) => {
        console.error("Login error:", error);
        setLoginLoading(false);
      });
  };

  useEffect(() => {
    if (loginError) {
      const loginErrorTimer = setTimeout(() => {
        setLoginLoading(false);
        dispatch(clearLoginError());
      }, 5000);

      return () => clearTimeout(loginErrorTimer);
    }
  }, [loginError, dispatch]);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className={styles.login_component_wrapper}>
      <div className={styles.login_component_logo_divider}>
        <span className={styles.logo_container}>
          <img src={logo} alt="ORMS Logo" className={styles.logo} />
        </span>
        <div className={styles.logo_text}>Liberia Chamber of Commerce</div>

        <div className={styles.website_link}><a href="https://liberiachamber.org" target="_blank" rel="noopener noreferrer">Go to website</a></div>
      </div>

      <div className={styles.login_component_form_divider}>
        <div className={styles.login_component_login_form_container}>
          <div className={styles.login_component_login_form_container_heading}>
            <h1>Welcome</h1>
            <p>Enter your credentials to access your account</p>
          </div>

          <form className={styles.loginform} onSubmit={handleSubmit}>
            <label htmlFor="email">Email</label>
            <section className={styles.username_section}>
              <input
                type="email"
                id="email"
                name="email"
                placeholder="Enter email"
                value={credentials.email || ""}
                onChange={handleChange}
              />
              {invalidEmailError && (
                <span className={styles.login_form_field_error_message}>
                  {invalidEmailError}
                </span>
              )}
            </section>

            <label htmlFor="password">Password</label>
            <section className={styles.password_section}>
              <input
                type={showPassword ? "text" : "password"}
                id="password"
                name="password"
                placeholder="Enter password"
                required
                value={credentials.password || ""}
                onChange={handleChange}
              />
              <span
                onClick={togglePasswordVisibility}
                className={styles.passwordToggleIcon}
              >
                {showPassword ? (
                  <VisibilityOffOutlined />
                ) : (
                  <VisibilityOutlined />
                )}
              </span>
            </section>

            <button type="submit" disabled={loginLoading}>
              {loginLoading ? (
                <span>Logging you in...</span>
              ) : (
                <span>Log in</span>
              )}
            </button>
            {loginError && (
              <span className={styles.login_error_message}>{loginError}</span>
            )}

            <NavLink to="/forgotpassword" className={styles.forgotpswd_txt}>
              Forgot Password?
            </NavLink>

            <div className={styles.optional_account_option}>
              Don't have an account? <NavLink to="/requestaccess" className={styles.account_option_txt}>Request access</NavLink>
            </div>
          </form>

          <div className={styles.trademark_txt}>Made with 💡 by <NavLink to="https://mwetana.com.lr/">MWETANA</NavLink></div>
        </div>
      </div>
    </div>
  );
};

export default Login;
